export const getters = {
  getFormaPagamento: (state) => state.formaPagamento,
  getFormasPagamento: (state) => state.formasPagamento,
  getModalExcluirFormaPagamento: (state) => state.modalExcluirFormaPagamento,
  getRecorrenciasFormaPagamento: (state) => state.recorrenciasFormaPagamento,
  getFormasPagamentoNfe: (state) => state.formasPagamentoNfe,
};

export default {};
